import React from "react";
import './heading.styles.scss';

const Heading = (props) =>
{
    return(
        <div>
            <h4 className="heading">{props.text}</h4>
        </div>
    )
}
export default Heading;